<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="config-list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            dialogWidth="60%"
            class="form-table-h360"
            :stripe="false"
            :addButton="{ enabled: true, permission: 'default' }"
            :deleteButton="{ enabled: false, permission: 'default' }"
            :spanMethod="spanMethod"
            :updateButton="{ enabled: false, permission: 'default' }"
            @removeItem="removeItem"
        >
            <slot slot="filter">
                <el-col :md="5" :xl="4">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域" :clearable="true"></item-input>
                </el-col>
            </slot>
            <!-- <slot slot="filter-after">
        <el-button type="primary" size="mini" >另存为</el-button>
      </slot>       -->
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SuppliesCountingConfig`,
    props: {},
    data() {
        return {
            title: `基础数据-耗材清点项配置`,
            o_dic_operating_ward_id: undefined, // 排程手术区
            issetoperatingward: false,
            url: {
                baseURL: `/api/AcisSystem/SuppliesCountingOperatingWardConfig`,
                get: query => {
                    return this.loadConfig()
                },
                put: row => {
                    return this.myaxios.put(
                        `api/AcisSystem/SuppliesCountingOperatingWardConfig/Put?operatingWardId=${row.dic_operating_ward_id}`,
                        _.map(row.dic_supplies, d => d.value)
                    )
                },
                post: row => {
                    return this.myaxios.put(
                        `api/AcisSystem/SuppliesCountingOperatingWardConfig/Put?operatingWardId=${row.dic_operating_ward_id}`,
                        _.map(row.dic_supplies, d => d.value)
                    )
                }
            },
            buttons: [],
            count_by_ow: undefined
        }
    },
    created() {},
    computed: {
        ...mapGetters([`sys_enums`, `operation_ward_auth`, `active_ward`]),
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `ID`,
                    isKey: true
                },
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    width: `300`,
                    isEditable: true,
                    isCreatable: true,
                    options: this.operation_ward_auth,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    isListable: true,
                    // config:{
                    //   collapseTags:false
                    // },
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `dic_supplies_name`,
                    label: `耗材`,
                    isListable: true,
                    isEditable: true,
                    readonly: true
                },
                {
                    //   type: "table2",
                    //   prop: "dic_supplies",
                    //   label: "耗材",
                    //   isListable: true,
                    //   isEditable: true,

                    // }, {
                    type: `remotemultiselect`,
                    prop: `dic_supplies`,
                    label: `耗材`,
                    isListable: false,
                    isEditable: false,
                    isCreatable: true,
                    options: `/api/AcisSystem/Supplies/Search`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `60`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            //   class:"is-plain",
                            //   label: "编辑",
                            //   icon:"",
                            //   type: "primary",
                            //   emit: "LoadingUpdateView",
                            //   permission: "default"
                            // },{
                            class: `is-plain`,
                            label: `删除`,
                            icon: ``,
                            type: `danger`,
                            emit: `removeItem`,
                            permission: `default`
                        }
                    ]
                }
            ]
        }
    },
    mounted() {},
    methods: {
        spanMethod({ row, column, rowIndex }) {
            if (column.property == `dic_operating_ward_id` && this.count_by_ow[row.dic_operating_ward_id]) {
                if (this.count_by_ow[row.dic_operating_ward_id].first == rowIndex) {
                    return [this.count_by_ow[row.dic_operating_ward_id].length, 1]
                } else {
                    return [0, 0]
                }
            } else {
                return [1, 1]
            }
        },
        loadConfig() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SuppliesCountingOperatingWardConfig/Get`)
                req.then(data => {
                    data = _.filter(data, d => {
                        return !this.dic_operating_ward_id || this.dic_operating_ward_id == d.dic_operating_ward_id
                    })
                    data = _.orderBy(data, [`dic_operating_ward_id`, `id`])
                    let owl = _.reduce(
                        _.groupBy(data, `dic_operating_ward_id`),
                        function(result, v, key) {
                            result[key || `-1`] = {
                                length: v.length,
                                first: -1
                            }
                            return result
                        },
                        {}
                    )
                    let r = _.map(data, (d, index) => {
                        if (owl[d.dic_operating_ward_id].first == -1) {
                            owl[d.dic_operating_ward_id].first = index
                        }
                        // d.id = d.dic_supplies_id
                        // d.dic_supplies= {label:d.supplies_model.name,value:d.dic_supplies_id}
                        d.dic_supplies_id = d.dic_supplies_id
                        d.dic_supplies_name = `${d.supplies_model.name}(${d.supplies_model.code})`
                        d.dic_operating_ward_id = d.dic_operating_ward_id
                        return d
                    })
                    this.count_by_ow = owl
                    resolve(r)
                }).catch(e => reject(e))
            })
        },
        removeItem({ row, index }) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.delete(`api/AcisSystem/SuppliesCountingOperatingWardConfig/Delete/${row.id}`)
                req.then(data => {
                    that.$message.success(`删除成功`)
                    that.$refs[`config-list`].ReloadListData()
                }).catch(e => {
                    that.$message.error(`删除失败`)
                })
            })
        }
    },
    watch: {
        dic_operating_ward_id: function() {
            this.$refs[`config-list`] && this.$refs[`config-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Counting/SuppliesCountingConfig.vue